import { render, staticRenderFns } from "./PriceConfigForm.vue?vue&type=template&id=7ce33a3d&"
import script from "./PriceConfigForm.vue?vue&type=script&lang=ts&"
export * from "./PriceConfigForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports